/* eslint-disable react-refresh/only-export-components */
import type { ReactNode } from 'react';
import React, { createContext, useContext } from 'react';

export type TenantId = 'vivechurch' | 'dev';

export type ApiLocation = 'cloud' | 'local';

export interface ApiConfig {
  tenant: TenantId;
  location: ApiLocation;
  baseUrl: string;
}

export interface Config {
  api: ApiConfig;
  debug: boolean;
}

const ConfigContext = createContext({} as Config);

export function ConfigProvider({
  config,
  children,
}: {
  config: Config;
  children: ReactNode;
}) {
  return React.createElement(
    ConfigContext.Provider,
    { value: config },
    children,
  );
}

export function useConfig() {
  return useContext(ConfigContext);
}
